import { useEffect, useRef } from 'react';

/**
 * Custom hook for smooth scrolling to an element when URL hash matches the specified hash
 * @param targetHash - The hash value to match (e.g., '#subscribe')
 * @returns A ref that should be attached to the target element
 */
export const useSmoothScrollToHash = <T extends HTMLElement = HTMLDivElement>(
  targetHash: string
) => {
  const elementRef = useRef<T | null>(null);

  useEffect(() => {
    if (window.location.hash === targetHash && elementRef.current) {
      elementRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [targetHash]);

  return elementRef;
}; 